module.exports = __webpack_public_path__ + "img/web2icon3.f2492c68.png";